import { COUNTRY_DOMAINS } from '../../common/constants';

export const NAVBAR_LOGO_BASED_ON_COUNTRY = {
  [COUNTRY_DOMAINS.id]: '/images/glints_for_id_employers.svg',
  [COUNTRY_DOMAINS.sg]: '/images/glints_for_sg_employers.svg',
  [COUNTRY_DOMAINS.my]: '/images/glints_for_employers.svg',
  [COUNTRY_DOMAINS.default]: '/images/glints_for_employers.svg',
};

export const SIDEBAR_LOGO_TEXT_BASED_ON_COUNTRY = {
  [COUNTRY_DOMAINS.id]: '/images/glints_text_id.svg',
  [COUNTRY_DOMAINS.sg]: '/images/glints_text_sg.svg',
  [COUNTRY_DOMAINS.default]: '/images/glints_text_default.svg',
};
